import { Injectable, signal } from '@angular/core';

/**
 * Service to track logout state across the application.
 * Prevents components from being accessed during logout process.
 */
@Injectable({ 
  providedIn: 'root' 
})
export class LogoutStateService {
  /**
   * Signal tracking whether logout is currently in progress
   */
  private readonly _isLoggingOut = signal(false);
  
  /**
   * Public readonly signal for checking logout state
   */
  public readonly isLoggingOut = this._isLoggingOut.asReadonly();
  
  /**
   * Sets the logout state
   * @param value true if logout is in progress, false otherwise
   */
  public setLoggingOut(value: boolean): void {
    this._isLoggingOut.set(value);
  }
}